export type ProjectFormFieldResponseValue = string | number | boolean | null

export function hasResponseValue(value: ProjectFormFieldResponseValue | undefined): boolean {
  if (typeof value === "string") return value.trim() !== ""
  return value != null
}

interface RequirableField {
  required: boolean
  field_type: string
}

// Household record fields are inapplicable to projects without a household; the
// backend exempts them from required checks in that case, so the frontend should too.
export function isFieldRequiredFor(field: RequirableField, householdId: string | null | undefined): boolean {
  if (!field.required) return false
  if (field.field_type === "boolean") return false
  if (field.field_type === "household_record" && !householdId) return false
  return true
}

export function findMissingRequiredFields<T extends RequirableField & { id: string }>(
  fields: readonly T[],
  responses: Record<string, ProjectFormFieldResponseValue>,
  householdId: string | null | undefined
): T[] {
  return fields.filter((f) => isFieldRequiredFor(f, householdId) && !hasResponseValue(responses[f.id]))
}
